// extracted by mini-css-extract-plugin
export default {"container":"style_container__GyTHy","titleSection":"style_titleSection__VbYuN"};